import moment from 'moment';

import { isBasketItemHeld } from '@store/basket/utils/isBasketItemHeld';

type SlotGuest = {
  firstName?: string;
  lastName?: string;
  externalSpaId?: number | string | null;
};

type BasketItemLike = {
  type?: string;
  checkIn?: string;
  expireAt?: string | null;
  bookable?: { ids?: { id?: number | string }; status?: string | null };
  guestDetails?: unknown;
};

const normaliseName = (value?: string) => (value || '').trim().toLowerCase();

const isSameGuest = (a: SlotGuest, b: SlotGuest) => {
  if (a.externalSpaId != null && b.externalSpaId != null) {
    return String(a.externalSpaId) === String(b.externalSpaId);
  }
  return (
    !!normaliseName(a.firstName) &&
    normaliseName(a.firstName) === normaliseName(b.firstName) &&
    normaliseName(a.lastName) === normaliseName(b.lastName)
  );
};

export function findGuestsBookedOnSlot(
  basketItems: unknown,
  classId: number,
  startDateTime: string,
  now = Date.now()
): SlotGuest[] {
  if (!Array.isArray(basketItems)) return [];

  const slotStart = moment(startDateTime);

  return (basketItems as BasketItemLike[])
    .filter(
      (item) =>
        item?.type === 'spa-classes' &&
        isBasketItemHeld(item, now) &&
        String(item.bookable?.ids?.id) === String(classId) &&
        !!item.checkIn &&
        moment(item.checkIn).isSame(slotStart)
    )
    .flatMap((item) =>
      Array.isArray(item.guestDetails) ? (item.guestDetails as SlotGuest[]) : []
    );
}

export function excludeGuestsBookedOnSlot<T extends SlotGuest>(
  guests: T[],
  bookedGuests: SlotGuest[]
): T[] {
  if (!bookedGuests.length) return guests;
  return guests.filter((guest) => !bookedGuests.some((booked) => isSameGuest(booked, guest)));
}
